import { BrowSerLocationState, BingMapCoordinates } from 'ts/types';
import { ApplicationState } from 'redux/reducers/index';

const selectBrowserLocation = (state: ApplicationState): BrowSerLocationState =>
  state.browserLocation;

export const selectBrowserLocationCoordinates = (
  state: ApplicationState,
): BingMapCoordinates | undefined => selectBrowserLocation(state).coordinates;

export const selectGeolocationStatusSelector = (
  state: ApplicationState,
): string | undefined => selectBrowserLocation(state).geolocationStatus;
